import dayjs from 'dayjs';
import { formatToCurrency } from '@/lib/helpers';

/**
 * Generate the Letter To Collectorate document
 *
 * @param {Object=} data - The data to be used to generate the document
 */
export const generateLetterToCollectorate = (data = {}) => {
  const bigMargin = 20;

  /**@type {import('pdfmake/interfaces').TDocumentDefinitions} */
  const dd = {
    footer: function (currentPage, pageCount) {
      return {
        text: `Page ${currentPage.toString()} of ${pageCount.toString()}`,
        alignment: 'center'
      };
    },
    info: {
      title: 'Letter To Collectorate', // name of the document being printed
      modDate: new Date(), // date the document was last modified
      creationDate: new Date(), // date the document was created
      keywords: 'Letter To Collectorate, loan, finance', // keywords associated with the document
      author: data.company?.name, // company name
      subject: 'Letter To Collectorate', // name of the document being printed
      creator: data.user?.username, // name of the logged in user
      producer: data.company?.name // company name
    },
    content: [
      data.company?.companyImage && {
        image: 'companyImage',
        alignment: 'center',
        fit: [80, 80]
      },
      {
        marginTop: 20,
        text: data.company?.name,
        alignment: 'center',
        fontSize: 22,
        bold: true
      },
      {
        marginBottom: bigMargin,
        text: 'Letter To Collectorate',
        alignment: 'center',
        fontSize: 14,
        marginBottom: bigMargin,
        bold: true
      },

      'Licensing Authority',
      'Collector of Taxes',
      { text: '______________________________', font: 'Roboto' },
      {
        text: '______________________________',
        font: 'Roboto',
        marginBottom: bigMargin
      },
      { text: 'Dear Sirs,', marginBottom: bigMargin / 2 },
      `Kindly accept this letter as my/our authority to deliver the original Certificate of Title for the captioned vehicle to the ${data?.company?.name} Company.`,
      {
        marginTop: bigMargin,
        marginBottom: bigMargin,
        text: [
          'DATED THIS  ',
          { text: '__________', font: 'Roboto' },
          '  DAY OF  ',
          { text: '__________________________', font: 'Roboto' },
          '  20',
          { text: '_____', font: 'Roboto' }
        ]
      },
      { text: '____________________________________________', font: 'Roboto' },
      { text: 'Name of JUSTICE OF THE PEACE', bold: true },
      {
        text: '____________________________________________',
        font: 'Roboto',
        marginTop: bigMargin
      },
      { text: 'JUSTICE OF THE PEACE for the Parish of', bold: true },
      {
        text: '____________________________________________',
        font: 'Roboto',
        marginTop: bigMargin
      },
      { text: 'Signature of JUSTICE OF THE PEACE', bold: true }
    ],
    images: {
      companyImage: data.company?.companyImage || ''
    },
    styles: {
      tableHeader: {
        bold: true
      },
      supSignature: {
        fontSize: 18,
        sup: true,
        alignment: 'center'
      },
      tableHeading: {
        alignment: 'left',
        fontSize: 16,
        bold: true
      }
    },
    defaultStyle: {
      font: 'Lora',
      color: '#111827',
      fontSize: 11,
      lineHeight: 1.3
    }
  };

  return dd;
};
